<template>
  <v-container id="disputas" tag="section">
    <base-v-component heading="Disputas de Stripe " />
    <base-material-card color="indigo" icon="mdi-hand" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-row no-gutters align="center">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="getDisputas()">
            <v-icon color="white">mdi-autorenew</v-icon>
          </v-btn>
        </v-row>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="disputas"
        :loading="loading"
        :search="search"
        sort-by="fecha"
        sort-desc
      >
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          sortable: false,
          text: "#",
          value: "id",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fechaCreada",
        },
        {
          sortable: false,
          text: "Fecha Límite",
          value: "fechaLimite",
        },
        {
          sortable: false,
          text: "Estado",
          value: "estadoMostrar",
        },
        {
          sortable: false,
          text: "Total",
          value: "total",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      search: "",
    };
  },
  computed: {
    ...mapState({
      disputasBruto: (state) => state.disputas.disputas,
    }),
    disputas() {
      return this.disputasBruto.map((d) => {
        return {
          ...d,
          fechaCreada: moment.unix(d.created).format("DD-MM-YYYY HH:mm"),
          total: parseFloat(d.amount / 100),
          estadoMostrar: d.status,
          fechaLimite: moment
            .unix(d.evidence_details.due_by)
            .format("DD-MM-YYYY HH:mm"),
        };
      });
    },
  },
  methods: {
    getDisputas() {
      this.loading = true;
      this.$store
        .dispatch("disputas/getDisputas")
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
</style>